import { apiClient } from './api.client';

export interface AnomalyFlag {
  id: string;
  productId: string;
  manufacturerId?: string;
  riskLevel: 'low' | 'medium' | 'high';
  riskScore: number;
  status: 'open' | 'acknowledged' | 'dismissed';
  reasons: string[];
  firstSeen: string;
  lastSeen: string;
  product?: {
    id?: string;
    name?: string;
    serialNumber?: number;
    batchId?: string;
    outerQrToken?: string;
    batch?: {
      id?: string;
      productName?: string;
      manufacturerId?: string;
      manufacturer?: {
        name?: string;
      };
    };
    packages?: Array<{
      id?: string;
      packageType?: string;
      qrToken?: string;
      parentPackageId?: string | null;
    }>;
  };
}

export interface AnomalyFlagFilters {
  productId?: string;
  manufacturerId?: string;
  status?: 'open' | 'acknowledged' | 'dismissed';
  riskLevel?: 'low' | 'medium' | 'high';
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
}

export interface AnomalyFlagResult {
  flags: AnomalyFlag[];
  total: number;
  hasMore: boolean;
}

class AnomalyFlagService {
  async getFlags(filters: AnomalyFlagFilters = {}): Promise<AnomalyFlagResult> {
    const params = new URLSearchParams();
    if (filters.productId) params.append('productId', filters.productId);
    if (filters.manufacturerId) params.append('manufacturerId', filters.manufacturerId);
    if (filters.status) params.append('status', filters.status);
    if (filters.riskLevel) params.append('riskLevel', filters.riskLevel);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.offset) params.append('offset', filters.offset.toString());

    const res = await apiClient.get(`/anomaly-flags?${params.toString()}`);
    return res.data?.data ?? res.data;
  }

  async updateFlagStatus(
    flagId: string,
    status: 'open' | 'acknowledged' | 'dismissed',
    notes?: string
  ): Promise<void> {
    await apiClient.put(`/anomaly-flags/${flagId}/status`, { status, notes });
  }

  async reopenFlag(flagId: string): Promise<void> {
    await apiClient.put(`/anomaly-flags/${flagId}/reopen`);
  }
}

export const anomalyFlagService = new AnomalyFlagService();
